<template>
  <div class="background-01">
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Decisiones efectivas "></ui-title-red>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Decisiones efectivas'" videoEmbed="ADMINISTRACIONDINERO9DecisionesEfectivas  (ant40).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm10 class="animated fadeInDown">
        <p>
          Para tomar decisiones
          <strong>efectivas</strong> hay que tener en cuenta que no es suficiente con ser
          <strong>eficiente</strong> o
          <strong>eficaz</strong>.<br><br> En el ejemplo de Juliana, veamos qué significa ahorrar el 10% de su sueldo de manera
          <strong>eficiente, eficaz o efectiva</strong>:
        </p>
      </v-flex>
    </v-layout>
    <br>
    <v-layout row wrap justify-center mt-5>
      <v-flex xs12 sm6 md5 text-xs-center class="animated fadeInLeft dura_1">
        <image-app :imaSize="400" imaSrc="contenido/diapositiva_11" imaAlt="Cuatro flechas apuntando al centro"></image-app>
      </v-flex>
      <v-flex xs12 sm6 md5 class="animated fadeInUp dura_2">
        <ui-numlist :bold="true" class="animated fadeInRight dura_2 adorn-bottom adorn-top" bullet="bullet-dav" :lista="lista"></ui-numlist>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      lista: [
        "<span class='font-red'>Eficiente: </span><span class='font-normal'>Hacer lo que debe hacer, es decir ahorrar el 10% de su sueldo.</span>",
        "<span class='font-red'>Eficaz: </span> <span class='font-normal'>Maximizar los recursos con los que se cuenta, es decir, generar un interés a partir del ahorro en el fondo de empleados.</span>",
        "<span class='font-red'>Efectiva: </span><span class='font-normal'>Asegurarse de causar el efecto e impacto deseado, es decir, poder utilizar el ahorro y el interés generado en un tiempo, para pagar la cuota inicial de su casa.</span>"
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// davivienda-10.vue?12b3d6de